module.exports = __webpack_public_path__ + "img/carousel5.0e874d6b.png";